<template>
  <div class="checkout" :class="{'is-loading': loading.trip}">
    <section class="octobus__section octobus__header"  v-if="!loading.trip">
      <div :class="{ 'octobus__container': !isFullWidth }">
        <h1 class="octobus__subtitle is-size-4-touch is-size-3-desktop">{{$t('checkout.title')}}</h1>
      </div>
    </section>
    <section class="octobus__section route-info"  v-if="!loading.trip">
      <div
        :class="{'multi-route' : index !== 0, 'octobus__container': !isFullWidth}"
        v-for="(trip, index) in trip.info"
        :key="trip.raceId"
      >
        <TripInfo
          :trip="trip"
          :passcount="passcount"
        />
      </div>
    </section>
    <section class="octobus__section checkout-trip" v-if="!loading.trip">
      <div :class="{ 'octobus__container': !isFullWidth }">
        <Passenger
          v-for="item in passcount"
          :key="item"
          :passenger="item"
          :trips="trip.info"
          :selectedPlace="placeByPassengers"
          @onUpdatePrice="updatePrice"
          @onUpdatePlace="updatePlace"
          @onUpdatePersonalInfo="updatePassenger"
        />
      </div>
    </section>
    <section class="octobus__section contact-info-wrapper"  v-if="!loading.trip">
      <div :class="{ 'octobus__container': !isFullWidth }">
        <ContactInfo
          :email="email"
          :phone="phone"
          :tripId="trip.id"
          :paysys="paysys"
          @changeEmail="setEmail"
          @changePhone="setPhone"
          @paysys:changed="setPaysys"
        />

        <div class="octobus__columns" v-if="$frameparams.brand === 'OrionBus'">
          <div class="octobus__column">
            <p style="color: #c6004b;">{{ $t('checkout.orion-msg') }}</p>
          </div>
        </div>

        <div class="octobus__columns">
          <div class="octobus__column">
            <div class="octobus__field">
              <input
                v-validate="'required'"
                class="is-checkradio"
                :class="{
                  'is-danger': isError('term'),
                  'is-primary': isSuccess('term'),
                }"
                id="term"
                type="checkbox"
                name="term"
              >
              <label for="term" v-html="$t('checkout.term', { ofertaurl })"></label>
            </div>
          </div>
        </div>
        <div class="octobus__columns is-vcentered">
          <div class="octobus__column">
            <div class="octobus__columns is-mobile">
              <div class="octobus__column is-flex-none">
                <p class="total is-size-3 is-inline-block-tablet">{{$t('checkout.sum')}}</p>
              </div>
              <div class="octobus__column">
                <p class="is-inline-block-tablet total has-text-right-touch has-text-primary is-size-3 has-text-weight-semibold-touch">{{totalPrice | currency(currencySymbol)}}</p>
              </div>
            </div>
          </div>
          <div :class="{'octobus__column': true, 'is-one-third-desktop': !canResv || !canResv}">
            <div class="octobus__columns is-mobile">
              <div class="octobus__column" v-if="canSale">
                <a
                  class="octobus__button is-primary is-fullwidth"
                  @click="onClickBuy()"
                  :disabled="!isSuccess('term')"
                  :class="{'is-loading': buying}"
                >{{$t('checkout.pay')}}</a>
              </div>
              <div class="octobus__column" v-if="canResv" :class="{ 'is-half is-offset-half': !canSale}">
                <a
                  class="octobus__button is-primary is-fullwidth"
                  @click="onClickBuy(true)"
                  :disabled="!isSuccess('term')"
                  :class="{'is-loading': reserving}"
                >{{$t('checkout.reserv')}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ErrorModal v-if="buyError" :show="true" :error="buyError" @hideModal="onHideError" />
  </div>
</template>

<script>
/* eslint object-shorthand: ["error", "always", { "ignoreConstructors": true }] */
/* eslint-env es6 */
import api from '@/api';
import { getCountryCode, setOrderData, getBuyerId, isUrlLang } from '@/utils/utils';
import ErrorModal from '@/components/_common/ErrorModal';
import TripInfo from './TripInfo/TripInfo';
import Passenger from './Passenger/Passenger';
import ContactInfo from './ContactInfo/ContactInfo';

export default {
  name: 'Checkout',
  components: {
    TripInfo,
    Passenger,
    ContactInfo,
    ErrorModal,
  },
  data() {
    return {
      trip: {
        info: [],
        id: '',
      },
      locale: this.$framelocale,
      priceByPassengers: {},
      placeByPassengers: {},
      passengers: {},
      query: this.$route.query,
      passcount: null,
      email: '',
      paysys: this.$frameparams.paysys[0],
      phone: {
        country: '+38',
        number: '',
      },
      loading: {
        trip: true,
      },
      buying: false,
      reserving: false,
      buyError: null,
    };
  },
  watch: {
    'trip.info'() {
      if (this.trip.info.some(ticket => ticket.countryFrom === 'RU') && this.trip.info.some(ticket => ticket.countryTo === 'RU')) {
        this.phone.country = '+7';
      }
    },
  },
  methods: {
    onClickBuy(reserve = false) {
      this.$validator.validateAll().then((validate) => {
        if (validate === true) {
          this.setProgress(reserve, true);
          api.Buy.buyinit().then((resinit) => {
            const { buyid, error: initError } = resinit;

            if (initError) {
              return Promise.reject();
            }

            const reserveMode = Number(reserve) === 1 ? this.$frameparams.reservemode : 0;
            const buyParams = {
              id: this.trip.id,
              buyid,
              reserveMode,
              places: this.getPlacesData(),
            };

            if (reserveMode === 0) {
              const returnToLocation = {
                name: 'Success',
                params: isUrlLang ? { locale: this.$UrlLang } : {},
              };
              const returnUrl = `${location.protocol}//${location.host}${this.$router.resolve(returnToLocation).route.path}`;
              buyParams.paymentSystem = this.paysys;
              buyParams.returnUrl = returnUrl;
            }

            const buyerId = getBuyerId();
            if (buyerId) {
              buyParams.buyerid = buyerId;
            }

            return api.Buy.buysite(buyParams).then((res) => {
              this.setProgress(reserve, false);
              /* eslint-disable no-param-reassign */
              const { payref, error } = res;

              if (error) {
                if (buyerId && typeof error === 'object' && error.code === 'E_ACCESSDENY') {
                  // just ignore the error expecting that sign in form will be shown to user
                  return false;
                }
                return Promise.reject(error.name);
              }

              res.buyid = buyid;
              res.reserve = reserve;
              if (reserve) {
                res.reserving = this.$frameparams.reserving;
              }

              setOrderData(res);
              if (reserve) {
                this.$router.push({ name: 'Success' });
              } else {
                location.href = payref;
              }
              return true;
            });
          }).catch((error) => {
            this.setProgress(reserve, false);
            this.buyError = (typeof error === 'string' || error instanceof String ? error : null) || this.$t('checkout.error');
          });
        }
      });
    },
    onHideError() {
      this.buyError = null;
    },
    setProgress(reserve, type) {
      if (reserve) {
        this.reserving = type;
      } else {
        this.buying = type;
      }

      return true;
    },
    isError(field) {
      return this.errors.has(field);
    },
    isSuccess(field) {
      return (
        !this.errors.has(field) &&
        this.fields[field] &&
        this.fields[field].dirty
      );
    },
    getPassengerData(currentPassengerPlaces, passengerId) {
      return Object.keys(currentPassengerPlaces)
        .map((raceId) => {
          const ticket = currentPassengerPlaces[raceId];
          const lgot = ticket.lgot;
          const email = this.email;
          const phone = `${this.phone.country}${this.phone.number}`;
          const place = ticket.place;
          const baggage = ticket.baggage || 0;
          const { lastName, name, passport, isDocNeed, descript, ...additionalFields } = this.passengers[passengerId];
          let additionalData = {};
          if (additionalFields && additionalFields.birthDay) {
            const [day, month, year] = additionalFields.birthDay.split('-');

            additionalData = {
              birthDay: `${year}-${month}-${day}`,
            };
          }

          const baseFields = {
            raceId,
            lgot,
            email,
            phone,
            baggage,
            place,
            name,
            lastName,
            passport,
            descript,
          };

          if (!isDocNeed) {
            return baseFields;
          }

          return { ...baseFields, ...additionalFields, ...additionalData };
        });
    },
    getPlacesData() {
      return Object.keys(this.passengers)
        .map((passengerId) => {
          const currentPassengerPlaces = this.placeByPassengers[passengerId];
          return this.getPassengerData(currentPassengerPlaces, passengerId);
        })
        .reduce((prev, curr) => prev.concat(curr), []);
    },
    setEmail(value) {
      this.email = value;
    },
    setPhone(value, type) {
      this.phone[type] = value;
    },
    setPaysys(paysys) {
      this.paysys = paysys;
    },
    updatePrice(passenger, totalPrice) {
      this.$set(this.priceByPassengers, passenger, totalPrice);
    },
    updatePlace(passenger, place) {
      this.$set(this.placeByPassengers, passenger, place);
    },
    updatePassenger(passenger, data) {
      this.$set(this.passengers, passenger, data);
    },
    prefillUser() {
      const { country, phone } = getCountryCode((this.$userData || {}).phone || this.$EventBus.$userData.phone);

      this.email = (this.$userData || {}).email || this.$EventBus.$userData.email || '';
      this.phone = {
        country,
        number: phone,
      };
    },
  },
  computed: {
    totalPrice() {
      const ids = Object.keys(this.priceByPassengers);

      return ids.reduce((sum, id) => sum + Number(this.priceByPassengers[id]), 0);
    },
    currencySymbol() {
      const name = this.$root.octobusCurrency ? this.$root.octobusCurrency.name : '';
      const currency = name || this.$root.octobusCurrencyObj;

      return typeof currency === 'object' ? currency.name : currency;
    },
    canResv() {
      return !this.trip.info
        .filter(trip => trip.canResv === 0).length;
    },
    canSale() {
      return !this.trip.info
        .filter(trip => trip.canSale === 0).length;
    },
    ofertaurl() {
      return this.$frameparams.oferta || '#';
    },
    isFullWidth() {
      return this.$fullwidth;
    },
  },
  created() {
    const { id } = this.query;
    this.passcount = Number(localStorage.getItem('__octobus__search-cnt')) || 1;

    api.Trip.info(id, this.passcount).then((res) => {
      const { error } = res;

      this.loading.trip = false;
      if (error) {
        this.error = error;
      } else {
        this.trip.id = id;
        // Temporary remove SERVICE discount, see OB-2500
        res.forEach((ride) => {
          ride.lgotes = (ride.lgotes || []).filter(l => l.param !== 'SERVICE');
        });
        this.trip.info = res;
      }
    });

    if (this.$userData || this.$EventBus.$userData) {
      this.prefillUser();
    }

    this.$EventBus.$on('auth__signin', this.prefillUser);

    this.$nextTick(() => {
      this.$el.scrollIntoView({ behavior: 'smooth' });
    });
  },
};
</script>

<style lang="scss">
#app, #auth {
  .checkout {

    .is-flex-none {
      flex: none !important;
    }

    p {
      margin: 0;
    }

    &.is-loading {
      height: 100vh;
    }

    .checkout-trip {
      padding: 3rem 0.5rem;
    }

    .octobus__header,
    .route-info {
      border-bottom: 1px solid #ececec;
    }

    .route-info {
      // box-shadow: 0 2px 4px rgba(0,0,0,.15);
      padding-top: 0;
      padding-bottom: 0;

      .multi-route {
        border-top: 1px dotted #ececec;
      }
    }

  }
}

/* Large Devices, Wide Screens */
@media only screen and (min-width : 768px) {
  #app {
    .checkout {
      .octobus__header {
        padding: 1rem 0.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue